module.exports = __webpack_public_path__ + "f395a001287c7f09ac607a2b0850393e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/berglind-osk.jpg
 ** module id = 402
 ** module chunks = 0
 **/